import React from 'react';

interface ActiveCrewFiltersProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  statusFilter: string;
  onStatusFilterChange: (value: string) => void;
  branchFilter: string;
  onBranchFilterChange: (value: string) => void;
  rankFilter: string;
  onRankFilterChange: (value: string) => void;
  uniqueBranches: string[];
  uniqueRanks: string[];
  getBranchName: (branchId: string) => string;
  filteredCount: number;
  totalCount: number;
  onExport: () => void;
  onPrint: () => void;
  onClearFilters: () => void;
}

const ActiveCrewFilters: React.FC<ActiveCrewFiltersProps> = ({
  searchTerm, onSearchChange,
  statusFilter, onStatusFilterChange,
  branchFilter, onBranchFilterChange,
  rankFilter, onRankFilterChange,
  uniqueBranches, uniqueRanks, getBranchName,
  filteredCount, totalCount,
  onExport, onPrint, onClearFilters,
}) => {
  const hasActiveFilters = searchTerm || statusFilter !== 'all' || branchFilter !== 'all' || rankFilter !== 'all';

  return (
    <div className="card">
      <div className="p-6 border-b border-gray-200">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-4 sm:space-y-0">
          <h2 className="text-xl font-semibold text-gray-900">أعضاء الطاقم النشط</h2>
          <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-3">
            <input
              type="text"
              placeholder="البحث في الطاقم النشط..."
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
              className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:w-64"
            />
          </div>
        </div>
      </div>

      <div className="p-6 bg-gray-50 border-b border-gray-200">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-6 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">الحالة</label>
            <select
              value={statusFilter}
              onChange={(e) => onStatusFilterChange(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
            >
              <option value="all">جميع الحالات</option>
              <option value="active">نشط</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">السفينة/المقر</label>
            <select
              value={branchFilter}
              onChange={(e) => onBranchFilterChange(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
            >
              <option value="all">جميع السفن/المقرات</option>
              {uniqueBranches.map(branchId => (
                <option key={branchId} value={branchId}>{getBranchName(branchId)}</option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">الرتبة</label>
            <select
              value={rankFilter}
              onChange={(e) => onRankFilterChange(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
            >
              <option value="all">جميع الرتب</option>
              {uniqueRanks.map(rank => (
                <option key={rank} value={rank}>{rank}</option>
              ))}
            </select>
          </div>

          <div className="flex items-end">
            <button
              type="button"
              onClick={onExport}
              className="w-full px-4 py-2 bg-green-600 text-white text-sm font-medium rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 transition-colors"
            >
              تصدير
            </button>
          </div>

          <div className="flex items-end">
            <button
              type="button"
              onClick={onPrint}
              className="w-full px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors"
            >
              طباعة
            </button>
          </div>

          <div className="flex items-end">
            <button
              type="button"
              onClick={onClearFilters}
              className="w-full px-4 py-2 bg-gray-600 text-white text-sm font-medium rounded-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 transition-colors"
            >
              مسح المرشحات
            </button>
          </div>
        </div>

        <div className="mt-4 flex items-center justify-between text-sm text-gray-600">
          <span>
            عرض {filteredCount} من {totalCount} عضو طاقم
          </span>
          {hasActiveFilters && (
            <span className="text-blue-600">تم تطبيق المرشحات</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ActiveCrewFilters;
